/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";

export type V1ProjectsGetProjectRequestBody = {
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  project: string;
};

/** @internal */
export type V1ProjectsGetProjectRequestBody$Outbound = {
  project: string;
};

/** @internal */
export const V1ProjectsGetProjectRequestBody$outboundSchema: z.ZodType<
  V1ProjectsGetProjectRequestBody$Outbound,
  z.ZodTypeDef,
  V1ProjectsGetProjectRequestBody
> = z.object({
  project: z.string(),
});

export function v1ProjectsGetProjectRequestBodyToJSON(
  v1ProjectsGetProjectRequestBody: V1ProjectsGetProjectRequestBody,
): string {
  return JSON.stringify(
    V1ProjectsGetProjectRequestBody$outboundSchema.parse(
      v1ProjectsGetProjectRequestBody,
    ),
  );
}
